import Vue from 'vue'

import MainMenu from '../components/common/MainMenu'
Vue.component('MainMenu', MainMenu)

import ButtonComponent from '../components/common/buttonComponent/ButtonComponent'
Vue.component('ButtonComponent', ButtonComponent)

import Loading from '../components/common/Loading'
Vue.component('Loading', Loading)

import ExamSearchItem from '../components/Exams/Register/ExamSearchItem'
Vue.component('ExamSearchItem', ExamSearchItem)

import vSelect from 'vue-select'
Vue.component('VSelect', vSelect)
// import 'vue-select/dist/vue-select.css'

Vue.component('ModelListSelect', {
  extends: vSelect,
  methods: {
    maybeAdjustScroll: () => false,
  },
})

import Modal from '../components/common/modals/Modal'
Vue.component('Modal', Modal)

import SvgLoader from '../components/common/SvgLoader'
Vue.component('SvgLoader', SvgLoader)

import ButtonBase from '../components/common/ButtonBase'
Vue.component('ButtonBase', ButtonBase)
